import apiClient from "../api/apiClient";
import { endPoints } from "../config/endpoints";
import tokenService from "./tokenService";

export const authService = {
  // Login with username and password
  login: async (data) => {
    const response = await apiClient.post(endPoints.auth.login, data);
    return response.data;
  },
  verifyOTP: async (data) => {
    const response = await apiClient.post(endPoints.auth.verifyOTP, data);
    return response.data;
  },
 
    async refreshToken() {

        const response = await apiClient.post(endPoints.auth.refreshToken, {
            refreshToken: tokenService.getRefreshToken()
        });
        return response.data;
    }
};

